import React, { Component } from "react";
import { Button, Card, Header } from "semantic-ui-react";

import CategoryForm from "./CategoryForm";

class Category extends Component {
  state = {
    isEditing: false
  };
  showEditForm = () => {
    this.setState({ isEditing: true });
  };
  hideEditForm = () => {
    this.setState({ isEditing: false });
  };
  render() {
    if (this.state.isEditing) {
      const { name, description, iconUrl, order } = this.props;
      const initialValues = { name, description, iconUrl, order };
      return (
        <CategoryForm
          hide={this.hideEditForm}
          initialValues={initialValues}
          submit={this.props.update}
          loading={this.props.updateLoading}
          defaultImages={this.props.defaultImages}
        />
      );
    }
    return (
      <Card fluid key={this.props.id}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem 2rem"
          }}
        >
          <div>
            <img src={this.props.iconUrl} alt={this.props.name} />
            <div>
              <Header>{this.props.name}</Header>
              <p>{this.props.description}</p>
            </div>
          </div>
          <div>
            <Button primary onClick={this.showEditForm}>
              Edit
            </Button>
            <Button
              negative
              loading={this.props.deleteLoading}
              onClick={this.props.delete}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card>
    );
  }
}
export default Category;



// WEBPACK FOOTER //
// ./src/pages/Categories/Category.js